import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { PageWrapper, Loader, Alert } from "../../components";
import { thunks as productThunks } from "../../redux/modules/products";
import Actions, { thunks } from "../../redux/modules/broadCast";
import BroadCastModal from "./components/broadcastModal";

class Broadcast extends React.Component {
  state = {
    broadCastToEdit: {},
    itemToDelete: null,
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(thunks.getBroadCast());
  }

  editBroadCast = (broadcast) => {
    this.setState({ broadCastToEdit: broadcast }, () => {
      this.handleAddBroadCast();
    });
  };

  onCategoryChange = (id) => {
    const { dispatch } = this.props;
    dispatch(productThunks.getCategories(id));
  };

  handleAddBroadCast = () => {
    this.resetChild();
    const { updateProperty } = this.props;
    updateProperty("showModal", true);
  };

  closeModal = () => {
    const { updateProperty } = this.props;
    updateProperty("showModal", false);
    this.setState({ broadCastToEdit: {} });
  };

  onAddBroadCast = (body) => {
    const { dispatch } = this.props;
    dispatch(thunks.addBroadCast(body));
  };

  onEditBroadCast = (body) => {
    const { dispatch } = this.props;
    dispatch(thunks.editBroadCast(body));
  };

  publishBroadCast = (id) => {
    const { dispatch } = this.props;
    dispatch(thunks.publishBroadCast(id));
  };

  delete = (user) => {
    this.setState({ itemToDelete: user });
  };

  handleDelete = () => {
    const { dispatch } = this.props;
    const { itemToDelete } = this.state;
    dispatch(thunks.deleteOrders(itemToDelete.id));
    this.setState({ itemToDelete: null });
  };

  render() {
    const {
      list,
      loading,
      error,
      updateProperty,
      categories,
      subCategories,
      showModal,
    } = this.props;
    const { broadCastToEdit, itemToDelete } = this.state;

    return (
      <PageWrapper title="Broadcast List">
        <Loader show={loading} />
        <Alert
          show={!!error}
          onHide={() => updateProperty("error", "")}
          title="Broadcast"
          message={error}
        />
        <div className="animated fadeIn">
          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-12 d-flex justify-content-end mb-3">
                      <button
                        className="btn btn-primary"
                        onClick={this.handleAddBroadCast}
                      >
                        <i className="fa fa-plus mr-2" />
                        Add
                      </button>
                    </div>
                  </div>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Description</th>
                          <th>Image</th>
                          <th>Type</th>
                          <th />
                          <th />
                        </tr>
                      </thead>
                      <tbody>
                        {list.length ? (
                          list.map((broadcast) => (
                            <tr key={broadcast.id}>
                              <td>{broadcast.id}</td>
                              <td>{broadcast.description}</td>
                              <td>
                                {broadcast.image_id ? (
                                  <img
                                    src={broadcast.image_id}
                                    alt={broadcast.description}
                                    width="80px"
                                  />
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>
                                <b
                                  className={
                                    broadcast.offer_id
                                      ? "text-success"
                                      : "text-primary"
                                  }
                                >
                                  {broadcast.offer_id ? "offers" : "products"}
                                </b>{" "}
                              </td>
                              <td>
                                <button
                                  title="Edit Banner"
                                  className="btn btn-info"
                                  onClick={() =>
                                    this.publishBroadCast(broadcast.id)
                                  }
                                >
                                  Publish
                                </button>
                              </td>
                              <td>
                                {
                                  <button
                                    title="View User"
                                    className="btn btn-xs btn-danger"
                                    onClick={() => this.delete(broadcast)}
                                  >
                                    <i className="fa fa-trash" />
                                  </button>
                                }
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="5" className="text-center">
                              No Records Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <BroadCastModal
          show={showModal}
          onHide={this.closeModal}
          categories={categories}
          subCategories={subCategories}
          data={broadCastToEdit}
          onCategoryChange={this.onCategoryChange}
          addBroadCast={this.onAddBroadCast}
          editBroadCast={this.onEditBroadCast}
          reset={(reset) => (this.resetChild = reset)}
        />
        <Alert
          show={!!itemToDelete}
          onHide={() => this.setState({ itemToDelete: null })}
          title="Delete BroadCast"
          message={`Are you sure you want to delete Uploaded BroadCast: ${
            (itemToDelete || {}).id
          }?`}
          onSubmit={this.handleDelete}
        />
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({
  broadCast: { loading, error, list, showModal },
  products: { categories, subCategories },
}) => ({
  loading,
  error,
  list,
  categories,
  subCategories,
  showModal,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
  reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Broadcast);
